
// import { SplitText } from 'gsap/SplitText';
import lottie from 'lottie-web';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import utils from '../utils';
let { isMobile, isPortrait, isTouchDevice } = utils;

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

class Preloader {
    constructor({ wrap, autoplay }) {
      this.wrap = wrap;
        this.autoplay = autoplay;
    }

    init() {
        let heroTL = gsap.timeline({ paused: true });
        let preloader = this.wrap.querySelector( '#preloader' );
        let hero = this.wrap.querySelector( '.hero' );
        let logo = this.wrap.querySelector( '.hero .powered' );
        let title = this.wrap.querySelector( '.hero .title' );
        let subtitle = this.wrap.querySelector( '.hero .subtitle' );
        let text = this.wrap.querySelector( '.hero .description' );
        let button = this.wrap.querySelector( '.hero .action' );
        let hero_image_1 = this.wrap.querySelector( '.hero .hero-image.image-1' );
        let hero_image_2 = this.wrap.querySelector( '.hero .hero-image.image-2' );
        let hero_image_3 = this.wrap.querySelector( '.hero .hero-image.image-3' );
        let menuBtn = this.wrap.querySelector( '.hero_menu-btn' );
        // let heroScroll = this.wrap.querySelector( '.hero .hero_scroll' );

        // let totalFrames = 0;
        // let endFrame = 0;

        // this.setWindowHeight();

        var splitTitle = new SplitText( title, { type: "lines", linesClass: "splitted-line-inner" });
        new SplitText( title, { type: "lines", linesClass: "splitted-line" });
        var splitSubitle = new SplitText( subtitle, { type: "lines", linesClass: "splitted-line-inner" });
        new SplitText( subtitle, { type: "lines", linesClass: "splitted-line" });
        var splitButton = new SplitText( button, { type: "lines", linesClass: "splitted-line-inner" });
        new SplitText( button, { type: "lines", linesClass: "splitted-line" });
        
        // this.preloaderAnim = lottie.loadAnimation({
        //   container: preloader,
        //   renderer: 'svg',
        //   loop: false,
        //   autoplay: false,
        //   rendererSettings: {
        //     preserveAspectRatio: 'xMidYMid slice',
        //     className: 'preloader_init',
        //   },
        //   path: isPortrait ? preloader.dataset.pathMobile : preloader.dataset.path
        // })
        
        // if(this.autoplay) window.lscroll.stop();

        // let scrollAnimation = lottie.loadAnimation({
        //   container: heroScroll,
        //   renderer: 'svg',
        //   loop: true,
        //   autoplay: false,
        //   path: '../scripts/lottie/scroll-down.json'
        // })

        gsap.set( [ title, subtitle, button ], { opacity: 1 });
        heroTL.fromTo( preloader, { opacity: 1 }, {
          opacity: 0,
          duration: 1
        }, 1 ).fromTo( [ splitTitle.lines, splitSubitle.lines ], { yPercent: 115 }, {
          yPercent: 0,
          ease: "expo.inOut",
          stagger: 0.08,
          duration: 2
        }, '-=0.5' ).to( text, {
          duration: 0.5,
          onStart: () => {
            text.classList.add( 'is-inview' );
          },
          onComplete: () => {
            text.classList.add( 'is-loaded' );
          }
        }, '-=0.6' ).fromTo( logo, {
          opacity: 0,
          duration: 0.5,
          scale: 0.5
        }, {
          opacity: 1,
          scale: 1,
          // stagger: 0.3
        }, '-=0.5' ).fromTo( splitButton.lines, { yPercent: 115 }, {
          yPercent: 0,
          ease: "expo.inOut",
          stagger: 0.08,
          duration: 1
        }, '-=0.6' ).fromTo( hero_image_1, {
          y: -100,
          opacity: 0
        } , {
          y: 0,
          opacity: 1,
          duration: 0.8
        }, '-=1' ).fromTo( hero_image_2, {
          x: 100,
          opacity: 0
        } , {
          x: 0,
          opacity: 1,
          duration: 0.8
        }, '-=0.5' ).fromTo( hero_image_3, {
          y: 100,
          opacity: 0
        } , {
          y: 0,
          opacity: 1,
          duration: 0.8,
          onComplete: () => {
            lscroll.update();
            setTimeout( () => {
              window.inTransition = false;
              lscroll.start();
            }, 800 );
            // scrollAnimation.play();
            window.isPreloaderDone = true;
            ev( 'preloaderDone', { preloaderAnim:this.preloaderAnim, endFrame: this.endFrame });
          }
        }, '-=0.5' ).fromTo( menuBtn, {
          opacity: 0,
          duration: 0.5,
          scale: 0
        }, {
          opacity: 1,
          scale:1,
          stagger: 0.3
        }, '-=1');
      // heroTL
      //       .fromTo(splitTitle.lines, {
      //         yPercent: 115,
      //       }, {
      //         yPercent: 0,
      //         ease: "expo.inOut",
      //         stagger: 0.08,
      //         duration: 2
      //       })
      //       .fromTo([logo, menuBtn], {
      //         duration: 0.5,
      //         scale: 0.5
      //       }, {
      //         opacity: 1,
      //         scale:1,
      //         stagger: 0.3
      //       }, '-=1')
      //       .fromTo(heroScroll, {
      //         y: -30,
      //         opacity: 0
      //       }, {
      //         y: 0,
      //         opacity: 1,
      //         duration: 0.5,
      //       }, '-=1');
        
        let preloaderEnd = 0;

        // this.preloaderAnim.addEventListener("loaded_images", () => {

        //   if(this.autoplay) this.loadFonts();
          
        //   this.playhead = { frame: 0 };
        //   this.totalFrames = this.preloaderAnim.totalFrames-1;
        //   this.endFrame = preloader.dataset.end == "full" ? this.totalFrames : +preloader.dataset.end;

        //   preloaderEnd = this.endFrame * (preloader.dataset.endMultiplier ? +preloader.dataset.endMultiplier : 0.9);
          
        //   gsap.to(preloader.querySelector('svg'), {
        //     opacity: 1,
        //     duration: 1
        //   })

        //   if(this.autoplay) this.start();
          
        // });

        let enteredFrame = false;

        // this.preloaderAnim.addEventListener("enterFrame", (e) => {
        //   if(!enteredFrame && e.currentTime > preloaderEnd) {
        //     enteredFrame = true;
        //     heroTL.play();
        //   }
        // })

        heroTL.play();
    }

    setWindowHeight() {
      let winHeight = window.innerHeight - 60 + 'px'
      if(isTouchDevice) $('.hero-video-holder').height(winHeight);
      document.documentElement.style.setProperty('--win-height', winHeight);
    }

    start() {
      gsap.delayedCall(0.2 , () => {
        ev('preloaderStarted', {});
        gsap.to(this.playhead, {
          frame: this.endFrame,
          duration: 1,//this.preloaderAnim.getDuration(false) * (this.endFrame/this.totalFrames),
          ease: "none",
          onUpdate: () => this.playhead && this.preloaderAnim.goToAndStop(this.playhead.frame, true),
        })
      });
    }

    loadFonts() {
      let link = document.createElement( "link" );
      link.href = "../fonts/stylesheet.css";
      link.type = "text/css";
      link.rel = "stylesheet";

      document.getElementsByTagName( "head" )[0].appendChild( link );
    }
}

export default ( wrap = document, autoplay = true ) => {
  if(document.getElementById('preloader')) {
    let preloader = new Preloader({ wrap, autoplay });
    window.preloader = preloader;
    preloader.init();
  
    return preloader;
  }
}